module.exports = __webpack_public_path__ + "img/amsterdam_lockdown_measures.fd67d2e2.png";